module.exports = __webpack_public_path__ + "static/media/jazzcash.e5108c8a.png";